module.exports = __webpack_public_path__ + "static/map-bg-3aa759301227ca69d9de22840a01ae12.png";